export default __webpack_public_path__ + "static/client7-5ef1a6997e6a476644e0591d66a0d2e3.png";